module.exports = __webpack_public_path__ + "3b8747b61e874ef74801d67f31a851e6.png";